function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M105.398 24.63h-31.15c-1.61 0-2.87 1.26-2.87 2.87v14.35c0 1.05.84 1.96 1.96 1.96s1.96-.84 1.96-1.96V28.48h29.26v60.97h-29.33V76.08c0-1.05-.84-1.96-1.96-1.96s-1.96.84-1.96 1.96v14.35c0 1.61 1.26 2.94 2.87 2.94h31.22c1.61 0 2.94-1.26 2.94-2.94V27.57c0-1.61-1.26-2.94-2.94-2.94z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M83.07 67.892c-.7.7-.84 1.89-.14 2.66.42.42.91.7 1.47.7.49 0 .98-.21 1.33-.56l10.71-10.71c.56-.56.56-1.4 0-1.96l-10.71-10.85c-.84-.84-2.24-.77-2.94.28-.49.77-.35 1.82.28 2.45l7.07 7.07H45.69c-.91 0-1.75.63-1.96 1.54-.21 1.26.7 2.31 1.89 2.31h44.52l-7.07 7.07z"
});

function SvgBenefit4Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 109 94"
  }, props), _ref, _ref2, _ref3);
}

export default SvgBenefit4Inline;